import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utilis/api";

export const fetchProducts = createAsyncThunk(
  "products/fetchProducts",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/products");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getProducts = createAsyncThunk(
  "products/getProducts",
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get("/products/get", { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);